import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {IModalDialogButton, ModalDialog} from '../../components/modal-dialog';
import {ModalDialogCommander} from '../../components/modal-dialog-commander';
import {SvgWrapper} from '../../components/svg-wrapper';
import {ClientFlowHelper} from '../helpers/client-flow-helper';
import {Models} from '../check-deposit-generated';
import {CampusAccessUtils} from '../utils/campus-access-utils';
import {BatchListStore} from './batch-list-store';
import BatchItemViewModel = Models.BatchItemViewModel;

export class BatchStillOpenDialog extends React.Component<{batch: BatchItemViewModel, store: BatchListStore}> {
	render() {
		const { batch, store } = this.props;
		const canAccessPortal = CampusAccessUtils.canAccessCheckScanningPortalForCampus(
			store.checkScanningPortalAccess,
			store.canAccessCheckScanningPortal,
			batch.CampusKey
		);

		const buttons: (IModalDialogButton | JSX.Element)[]  = [
			{ label: 'Back to list', dismiss: true, isPrimary: false, hideOnProgress: true }
		];

		if (canAccessPortal) {
			buttons.push(
				<button type="button" className="btn btn-default" onClick={this.openCheckScanningPortal}>
					<SvgWrapper svg="icon-follow-link" className="icon" />
					Close Deposit
				</button>
			);
		}

		return(
			<ModalDialog title="This deposit is still open" buttons={buttons}>
				Please close this deposit in the check scanning portal before you start allocating transactions.
				{
					store.checkScanningPortalAccess && store.checkScanningPortalAccess.length > 1 ?
					<div>
						<div style={{marginTop: '15px'}}>
							<span style={{color: '#d9534f', fontWeight: 'bold'}}>Important note:</span> After closing a
							deposit, log out of ProfitStars to avoid scanning checks to the wrong campus.
						</div>
					</div> : null
				}
			</ModalDialog>
		);
	}

	private openCheckScanningPortal = () => {
		ClientFlowHelper.openCheckScanningPortalWindow(this.props.batch.CampusKey);
		ModalDialogCommander.close(ReactDOM.findDOMNode(this));
	}
}
